import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

// progresss
export function listKkonsul(data) {
  return request({
    url: MLMReport() + "/konsultasi/index",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function valid(data) {
  return request({
    url: MLMReport() + "/konsultasi/validation_add",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function add(data) {
  return request({
    url: MLMReport() + "/konsultasi/add_stored",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function dataDokter(data) {
  return request({
    url: MLMReport() + "/member/list_member",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/consultation.js